import { AuthGuard } from '@/components/auth-guard';
import { Layout } from '@/components/layout';
import { AdminPage } from '@/pages/admin';
import { AttackPathsPage } from '@/pages/attack-paths';
import { CallbackPage } from '@/pages/callback';
import { DashboardPage } from '@/pages/dashboard';
import { IncidentDetailPage } from '@/pages/incident-detail';
import { IncidentsPage } from '@/pages/incidents';
import { InventoryAccessPage } from '@/pages/inventory-access';
import { InventoryAccessDetailPage } from '@/pages/inventory-access-detail';
import { InventoryActionDetailPage } from '@/pages/inventory-action-detail';
import { InventoryActionsPage } from '@/pages/inventory-actions';
import { LoginPage } from '@/pages/login';
import { NotFoundPage } from '@/pages/not-found';
import { PoliciesPage } from '@/pages/policies';
import { PosturePage } from '@/pages/posture';
import { PostureRepoDetailPage } from '@/pages/posture-repo-detail';
import { SettingsPage } from '@/pages/settings';
import { BrowserRouter, Route, Routes } from 'react-router';

export function AppRouter() {
	return (
		<BrowserRouter>
			<Routes>
				{/* Public routes */}
				<Route path="/login" element={<LoginPage />} />
				<Route path="/auth/callback" element={<CallbackPage />} />

				{/* Authenticated routes */}
				<Route element={<AuthGuard />}>
					<Route element={<Layout />}>
						<Route index element={<DashboardPage />} />
						<Route path="incidents" element={<IncidentsPage />} />
						<Route path="incidents/:id" element={<IncidentDetailPage />} />
						<Route path="inventory/access" element={<InventoryAccessPage />} />
						<Route path="inventory/access/detail/*" element={<InventoryAccessDetailPage />} />
						<Route path="inventory/actions" element={<InventoryActionsPage />} />
						<Route path="inventory/actions/detail/*" element={<InventoryActionDetailPage />} />
						<Route path="policies" element={<PoliciesPage />} />
						<Route path="posture" element={<PosturePage />} />
						<Route path="posture/repos/*" element={<PostureRepoDetailPage />} />
						<Route path="attack-paths" element={<AttackPathsPage />} />
						<Route path="settings" element={<SettingsPage />} />
						<Route path="admin" element={<AdminPage />} />
						<Route path="*" element={<NotFoundPage />} />
					</Route>
				</Route>
			</Routes>
		</BrowserRouter>
	);
}
